// @ts-check
/** @typedef {import('../../../shared/api/types').StudentStreakResponse} StudentStreakResponse */

import { apiRequest } from '../../../shared/api/base';

/**
 * Get streak data for a specific student
 * @param {string} studentId - The student ID
 * @returns {Promise<StudentStreakResponse>} Student streak data
 */
export const getStudentStreak = async (studentId) => {
  return await apiRequest(`/streaks/${studentId}`);
};
